import cssUtil from 'gw-portals-util-js/CssUtil';

import templateStr from 'text!./stepper.html';
import styles from 'edge/platform/widgets/inputs/stepper/Stepper-hashed.scss';

var hashedTemplate = cssUtil.hashTemplate(templateStr, styles);

/** Base stepper directive. This one is responsible for displaying a current value and for displaying
 * "previous" and "next" buttons.
 */

export default [function () {
    return {
        restrict: 'A',
        template: hashedTemplate,

        scope: {
            'displayValue': '=',
            'havePrevValue': '=',
            'haveNextValue': '=',
            'selectPrevValue': '&',
            'selectNextValue': '&'
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/stepper/Stepper.js
// module id = 784
// module chunks = 0